<template>
  <div class="header">
      <!-- 头部-右侧背景图 左侧title 左侧desc -->
      <img class="right_bg" :src="header.ambientImg" />
      <div class="left">
        <img class="left_title" :src="header.titleImg" />
        <span class="left_desc">{{ruleMap[rankType] && ruleMap[rankType].content}}</span>
        <!-- 榜单 品类-->
        <slot/>
        <!-- 榜单 -->
      </div>
    </div>
</template>
<script>
export default {
  name: 'oldHeader',
  props: {
    header: {
      type: Object
    },
    ruleMap: {
      type: Object
    },
    rankType:{
      type: [String, Number]
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  .right_bg {
    width: 100%;
  }
  .left {
    position: absolute;
    top: 176px;
    left: 0;
    display: flex;
    flex-direction: column;
    .left_title {
      max-width: 453px;
      // height: 222;
    }
    .left_desc {
      margin-left: 48px;
      width: 480px;
      opacity: 0.8;
      font-family: DiDiSans-Pro-Medium;
      font-size: 24px;
      color: #975425;
      letter-spacing: 0;
      line-height: 30px;
      font-weight: 400;
    }
  }
}
</style>